import { IncomingMessage } from 'http';

import { fechFromBPartsApi } from '../utils';

const fetchUniqueVehicle = async (
  {
    locale,
    vehicle,
    detailed_prices = false,
    is_advanced_view = false,
  }: {
    locale: string;
    vehicle: string;
    detailed_prices: boolean;
    is_advanced_view: boolean;
  },
  req?: IncomingMessage
): Promise<TVehicle> => {
  return fechFromBPartsApi<TVehicle>(
    `/${locale}/shop/vehicles/${encodeURI(
      vehicle
    )}?detailed_prices=${detailed_prices.toString()}&is_advanced_view=${is_advanced_view.toString()}`,
    {
      headers: req ? new Headers(req.headers as HeadersInit) : undefined,
      credentials: 'include',
    },
    { enableCustomErrorWrapper: true }
  );
};

export default fetchUniqueVehicle;
